const features = [
  {
    icon: "ri-scan-2-line",
    title: "Dinamik QR Kodlar",
    desc: "İçeriği istediğiniz zaman güncelleyin. Yazdırılmış kodlar bile değiştirilir.",
    color: "text-blue-600 bg-blue-50",
  },
  {
    icon: "ri-bar-chart-2-line",
    title: "Gerçek Zamanlı İstatistikler",
    desc: "Hangi ülkeden, ne zaman, hangi cihazla tarandığını anlık olarak görün.",
    color: "text-sky-600 bg-sky-50",
  },
  {
    icon: "ri-download-2-line",
    title: "Çoklu Format İndirme",
    desc: "PNG, SVG ve PDF formatlarında yüksek çözünürlüklü dosyalar indirin.",
    color: "text-indigo-600 bg-indigo-50",
  },
  {
    icon: "ri-brush-line",
    title: "Tam Özelleştirme",
    desc: "Logo, renk, çerçeve ve desen seçenekleriyle markanıza özel tasarım.",
    color: "text-blue-600 bg-blue-50",
  },
  {
    icon: "ri-shield-check-line",
    title: "Güvenli & Güvenilir",
    desc: "%99.9 çalışma süresi garantisi ile kodlarınız her zaman erişilebilir.",
    color: "text-sky-600 bg-sky-50",
  },
  {
    icon: "ri-global-line",
    title: "150+ Ülke Desteği",
    desc: "Dünya genelinde kullanıcılarınıza kesintisiz hizmet sunun.",
    color: "text-indigo-600 bg-indigo-50",
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-24 bg-slate-50/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-blue-600 text-sm font-semibold uppercase tracking-widest">Özellikler</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-3">
            Gelişmiş QR Kod Oluşturucu
          </h2>
          <p className="text-slate-500 mt-4 max-w-xl mx-auto">
            İhtiyacınız olan tüm araçlar tek bir platformda. Profesyonel sonuçlar, kolay kullanım.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl p-6 border border-slate-100 hover:border-blue-200 transition-all group cursor-default"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${feature.color} transition-transform group-hover:scale-110`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-slate-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}